<template>
    <dash
        icon="fa fa-users"
        titulo="USUÁRIOS"
        @click.native="$router.push({ name: rota })"
    ></dash>
</template>

<script>
import Dash from './../../../shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    props: {
        rota: {
            type: String,
            default: () => 'Usuarios'
        }
    },

    data() {
        return {}
    }
}
</script>
